var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-card-actions',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v("© "+_vm._s(new Date().getFullYear())+" David LUN")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }